













































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { isAudioFile, isImageFile, isMediaFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { FormFileUpload } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import FileImageView from "./components/FileImageView";
import MediaImageView from "./components/MediaImageView";

export default defineComponent({
  name: "FilePreview",
  components: {
    BaseIcon,
    BaseIconButton,
    MediaImageView,
    LoadingThumbnail,
    FileImageView,
  },
  props: {
    data: { type: Object as PropType<FormFileUpload>, required: true },
    hideCloser: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
  },
  setup(props) {
    const file = computed(() => props.data.file);

    const fileName = computed(() => {
      if (!file.value) return "";
      if ("fileName" in file.value) {
        return file.value.fileName;
      }
      if ("name" in file.value) {
        return file.value.name;
      }
      return undefined;
    });

    const processingError = computed(
      () => !!file.value && "processingStatus" in file.value && file.value.processingStatus === "ERROR"
    );

    const icon = computed(() => {
      if (!file.value) return "";
      if (isVideoFile(file.value)) return "sci-video";
      if (isImageFile(file.value)) return "sci-image";
      if (isAudioFile(file.value)) return "sci-music-note-fill";
      return "msr-docs";
    });

    const src = computed(() => {
      if (!file.value) return "";
      if ("urlPart" in file.value && file.value.urlPart) {
        if (isVideoFile(file.value)) return MediaFilesController.getVideoThumbnail(file.value.urlPart, "480p");
        if (isImageFile(file.value)) return MediaFilesController.getImageThumbnail(file.value.urlPart, "480p");
      } else if (file.value instanceof File) {
        return isImageFile(file.value) ? URL.createObjectURL(file.value) : "";
      }
      return "";
    });

    const duration = computed(() => {
      if (file.value && "metadata" in file.value && file.value.metadata.duration)
        return getMediaDuration(+file.value.metadata.duration);
      return "";
    });

    const isMedia = computed(() => !!file.value && isMediaFile(file.value));

    return { processingError, icon, src, duration, isMedia, fileName };
  },
});
